"use strict";

module.exports = {
    "attach": {
        "button-text": "Файлды таңдау",
        "no-file": "файл таңдалған жоқ"
    }
};